<script>
import Vue from 'vue';
import DashboardAvailability from '../DashboardAvailability/DashboardAvailability.vue';
import DashboardNotifications from '../DashboardNotifications/DashboardNotifications.vue';
import {mapState, mapActions} from 'vuex';
import store from '../../store';
import Alert from '../Alert/Alert.vue';
import Loading from '../Loading/Loading.vue';
import InfoWidget from '../InfoWidget/InfoWidget.vue';
import DashboardWelcome from '../DashboardWelcome/DashboardWelcome.vue';

export default Vue.extend({
    components: {
        Alert,
        Loading,
        InfoWidget,
        DashboardWelcome,
        DashboardAvailability,
        DashboardNotifications
    },
    computed: {
        ...mapState({
            loading: state => state.dashboard.notifications.dismiss.loading,
            notificationsLoading: state => state.dashboard.notifications.loading,
            availabilityLoading: state => state.dashboard.availability.loading,
            tips: state => state.dashboard.dashboardPage.tips,
            user: state => state.auth.user,
            supplier: state => state.auth.supplier
        })
    },
    watch: {
        supplier: (supplier) => {
            if (!supplier.id) {
                return;
            }
            store.dispatch('dashboard/getAvailabilityBySupplierId', supplier.id);
            store.dispatch('dashboard/getAccommodationNotificationsBySupplierId', supplier.id);
        }
    },
    created () {
        const supplierId = this.supplier.id;
        if (!supplierId) {
            return;
        }
        this.getAvailabilityBySupplierId(supplierId);
        this.getAccommodationNotificationsBySupplierId(supplierId);
    },
    beforeRouteLeave(to, from, next) {
        Promise.all([
            this.$refs.infoWidget.clean()
        ]).then(() => {
            next();
        });
    },
    destroyed() {
        this.resetState();
    },
    methods: {
        ...mapActions({
            resetState: 'dashboard/resetState',
            getAvailabilityBySupplierId: 'dashboard/getAvailabilityBySupplierId',
            getAccommodationNotificationsBySupplierId: 'dashboard/getAccommodationNotificationsBySupplierId'
        })
    }
});
</script>
<template>
    <div class="dashboard-page">
        <dashboard-welcome/>
        <dashboard-availability/>
        <dashboard-notifications/>
        <loading v-if="loading | notificationsLoading | availabilityLoading"/>
        <alert :translation-prefix="'dashboard.alert'"/>
        <info-widget ref="infoWidget" :tips="tips"/>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/DashboardPage/DashboardPage.vue